import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';


export const selectEventDetails = (state: IRootMachineSnapshot) =>
  state.context.eventDetails;
